
export default function Hero() {
  const scrollToOrder = () => {
    document.getElementById('pedido')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      id="inicio"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat pt-16"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), url('https://static.readdy.ai/image/1c25e8811aca7c6ca186f30e4b2227d5/c915826265fb26828b706aa4e1f94191.png')`
      }}
    >
      <div className="container mx-auto px-4 py-12 sm:py-20">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold mb-4 sm:mb-6 leading-tight text-white drop-shadow-2xl">
            Gás é Oxigênio Iturama
            <br />
            <span className="text-red-400 text-lg sm:text-xl md:text-3xl">Servindo a cidade há 35 anos</span>
          </h1>
          
          <p className="text-base sm:text-lg md:text-2xl mb-8 sm:mb-10 text-white max-w-3xl mx-auto font-medium drop-shadow-lg px-4">
            Trocamos seu gás em minutos. Pedido fácil pelo WhatsApp ou telefone.
          </p>

          <div className="mb-8 sm:mb-12 px-4">
            <button 
              onClick={scrollToOrder}
              className="bg-red-600 text-white px-6 py-3 sm:px-8 sm:py-4 md:px-12 md:py-6 rounded-full text-base sm:text-lg md:text-2xl font-bold hover:bg-red-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-2xl border-2 sm:border-4 border-white w-full sm:w-auto"
            >
              <i className="ri-shopping-cart-fill mr-2 sm:mr-3"></i>
              FAÇA SEU PEDIDO AGORA
            </button>
          </div>

          {/* Quick Info Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8 max-w-4xl mx-auto px-4">
            <div className="bg-white/20 backdrop-blur-md rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 text-center border border-white/30 shadow-xl">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-time-fill text-white text-lg sm:text-xl md:text-2xl"></i>
              </div>
              <h3 className="font-bold text-lg sm:text-xl mb-2 sm:mb-3 text-white">Entrega em minutos</h3>
              <p className="text-gray-100 text-sm sm:text-base">Receba seu gás rapidamente em casa</p>
            </div>

            <div className="bg-white/20 backdrop-blur-md rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 text-center border border-white/30 shadow-xl">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-shield-check-fill text-white text-lg sm:text-xl md:text-2xl"></i>
              </div>
              <h3 className="font-bold text-lg sm:text-xl mb-2 sm:mb-3 text-white">Segurança e Qualidade</h3>
              <p className="text-gray-100 text-sm sm:text-base">Botijões certificados e seguros</p>
            </div>

            <div className="bg-white/20 backdrop-blur-md rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 text-center border border-white/30 shadow-xl sm:col-span-2 md:col-span-1">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-phone-fill text-white text-lg sm:text-xl md:text-2xl"></i>
              </div>
              <h3 className="font-bold text-lg sm:text-xl mb-2 sm:mb-3 text-white">Pedido fácil</h3>
              <p className="text-gray-100 text-sm sm:text-base">Peça por telefone ou WhatsApp</p>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Action Button - Hidden on small screens to avoid overlap */}
      <div className="hidden sm:block fixed bottom-6 right-6 z-40">
        <button 
          onClick={scrollToOrder}
          className="bg-red-600 text-white p-3 sm:p-4 rounded-full shadow-2xl hover:bg-red-700 transition-all transform hover:scale-110 cursor-pointer animate-pulse"
        >
          <i className="ri-shopping-cart-fill text-xl sm:text-2xl"></i>
        </button>
      </div>
    </section>
  );
}
